import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";

import { USER_LOGOUT } from "graphql/mutation/user-gql";
import { IS_LOGGED_IN } from  "graphql/query/local-store-gql";

import { errorNotification } from "../request-result";
import {useVarParam} from "./index";


const useLogout = () => {

    const history = useHistory(),
          [userLogout, {client}] = useMutation( USER_LOGOUT );

    const varParam = useVarParam();

    const clearStore = ({ route = false }) => {

        localStorage.clear();
        //client.resetStore().catch((error) => { //console.log(error)});

        client.cache.reset().then(
            () => {
                if(route !== undefined && route && varParam.get("profileComplete")){
                    history.push(route);
                }
            }
        );

    };

    const logout = ({ redirectRoute = "/"}) => {
        userLogout({
            update(cache) {

                cache.writeQuery({
                    query: IS_LOGGED_IN,
                    data: {
                        isLoggedIn: false
                    },
                });

                setTimeout( () => {
                    clearStore({ route: redirectRoute })
                }, 500 );
            }
        }).catch((error) => {
            errorNotification(error);
        });
    };

    return {
        logout, clearStore
    };

};

export default useLogout;